// Day numbers when a new named movement is introduced in the Year 1
// program. Keyed by path ('A' | 'B'), value is an array of movement
// intro entries, sorted by `day`.
//
// A movement entry renders ONLY on its exact day — the card below the
// hero disappears the next morning. This matches the behaviour the
// Year 1 redesign expects from Year1NewMovementCard.
//
// Path A and Path B have different introduction schedules because the
// paths have different pacing — Path B (the "Release First" 30-day
// reconnection ramp) delays most new movements by 30+ days.

export const NEW_MOVEMENT_DAYS = {
  A: [
    {
      day: 61,
      name: 'Pulsação',
      name_pt: 'Pulsação',
      description: 'Fast rhythmic contractions. One second on, one second off. Each rep is independent.',
      description_pt: 'Contrações rítmicas rápidas. Um segundo contraindo, um segundo soltando. Cada repetição começa do zero.',
    },
    {
      day: 121,
      name: 'Aperto',
      name_pt: 'Aperto',
      description: 'The lateral squeeze. Press the side walls inward toward the center. A new plane of control.',
      description_pt: 'O aperto lateral. Pressione as paredes laterais em direção ao centro. Um novo plano de controle.',
    },
    {
      day: 151,
      name: 'Ordenha',
      name_pt: 'Ordenha',
      description: 'The ascending and descending squeeze. Three levels, one fluid motion.',
      description_pt: 'O aperto ascendente e descendente. Três níveis, um movimento fluido.',
    },
    {
      day: 181,
      name: 'Onda',
      name_pt: 'Onda',
      description: 'Front wall then back wall. An alternating wave through the full canal.',
      description_pt: 'Parede frontal depois posterior. Uma onda alternada por todo o canal.',
    },
    {
      day: 211,
      name: 'Vibração',
      name_pt: 'Vibração',
      description: 'Rapid pulses at depth. Speed and precision combined.',
      description_pt: 'Pulsos rápidos em profundidade. Velocidade e precisão combinadas.',
    },
    {
      day: 271,
      name: 'Circular',
      name_pt: 'Circular',
      description: 'Clockwise and counter-clockwise rotation through all four walls. The full 3D method.',
      description_pt: 'Rotação no sentido horário e anti-horário por todas as quatro paredes. O método 3D completo.',
    },
  ],
  B: [
    {
      day: 181,
      name: 'Aperto',
      name_pt: 'Aperto',
      description: 'The lateral squeeze. Press the side walls inward toward the center. A new plane of control.',
      description_pt: 'O aperto lateral. Pressione as paredes laterais em direção ao centro. Um novo plano de controle.',
    },
    {
      day: 211,
      name: 'Ordenha',
      name_pt: 'Ordenha',
      description: 'The ascending and descending squeeze. Three levels, one fluid motion.',
      description_pt: 'O aperto ascendente e descendente. Três níveis, um movimento fluido.',
    },
    {
      day: 241,
      name: 'Onda',
      name_pt: 'Onda',
      description: 'Front wall then back wall. An alternating wave through the full canal.',
      description_pt: 'Parede frontal depois posterior. Uma onda alternada por todo o canal.',
    },
    {
      day: 271,
      name: 'Vibração',
      name_pt: 'Vibração',
      description: 'Rapid pulses at depth. Speed and precision combined.',
      description_pt: 'Pulsos rápidos em profundidade. Velocidade e precisão combinadas.',
    },
    {
      day: 301,
      name: 'Circular',
      name_pt: 'Circular',
      description: 'Clockwise and counter-clockwise rotation through all four walls. The full 3D method.',
      description_pt: 'Rotação no sentido horário e anti-horário por todas as quatro paredes. O método 3D completo.',
    },
  ],
};

/**
 * Return the new-movement intro entry for a given day, or null if
 * no movement is introduced on that day. Unknown paths fall back to A.
 *
 * @param {number} dayNumber  1..360
 * @param {'A'|'B'} path      training path (defaults to 'A')
 * @returns {object|null}     { day, name, name_pt, description, description_pt }
 */
export function getNewMovementForDay(dayNumber, path = 'A') {
  const days = NEW_MOVEMENT_DAYS[path] || NEW_MOVEMENT_DAYS.A;
  return days.find((m) => m.day === dayNumber) || null;
}
